
/**
 * GROUNDING DOCUMENTATION
 * This file contains textbook excerpts and clinic protocols.
 * When textbooks are uploaded to the chat, I will extract high-yield content
 * and place it here to ground the AI's generation logic.
 */

export const GROUNDING_KNOWLEDGE = `
*** OFFICIAL SURGICAL GROUNDING DOCUMENTATION ***

1. GENERAL APPROACH PRINCIPLES:
- All reports must reflect DACVS standards for precision and clinical voice.
- Use passive voice for surgical descriptions.
- Anatomical precision (cranial/caudal) is mandatory.

[WAITING FOR TEXTBOOK UPLOADS...]
- Once you upload your textbooks, I will extract specific protocols for TPLO, GDV, Hemilaminectomy, etc.
- This information will be used as the "source of truth" for the AI.
`;
